import script from "./OperatorApplicationConfigShortcuts.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationConfigShortcuts.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationConfigShortcuts.vue?vue&type=style&index=0&id=567bccd3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567bccd3"]])

export default __exports__